/* @flow */

import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import ResourceDimmer from 'shared/components/ResourceDimmer';
import ResourcesGallery from 'shared/components/ResourcesGallery';
import ImageCrop from 'shared/components/ImageCrop';
import { getImage } from 'utils/resources';

type Props = {
  resources: Array<BucketResource>,
  resource: BucketResource,
  onCrop: (resource: BucketResource, crop: CropConfig) => void,
};

type State = {
  galleryOpen: boolean,
};

class Image extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      galleryOpen: false,
      cropOpen: false,
    };
  }

  showGallery = () => this.setState({ galleryOpen: true });
  hideGallery = () => this.setState({ galleryOpen: false });

  showCrop = () => this.setState({ cropOpen: true });
  hideCrop = () => this.setState({ cropOpen: false });

  onCropComplete = (crop: CropConfig) => {
    const { resource, onCrop } = this.props;
    onCrop(resource, crop);
    this.hideCrop();
  };

  render() {
    const { resource, resources } = this.props;
    const { galleryOpen, cropOpen } = this.state;

    return (
      <ResourceDimmer resource={resource}>
        <div>
          <Button.Group attached="top" basic inverted vertical>
            <Button icon="play" content="Voir" onClick={this.showGallery} />
            <Button
              icon="crop"
              content="Redimensionner"
              onClick={this.showCrop}
            />
          </Button.Group>
          <ImageCrop
            open={cropOpen}
            image={getImage(resource, 'xhdpi_2x')}
            onComplete={this.onCropComplete}
            onClose={this.hideCrop}
          />
          <ResourcesGallery
            index={resources.indexOf(resource)}
            isOpen={galleryOpen}
            resources={resources}
            onClose={this.hideGallery}
          />
        </div>
      </ResourceDimmer>
    );
  }
}
export default Image;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folder/components/items/Image.js